import { createContext, useContext, useState, useCallback, useMemo } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { clearEventDetailsCache } from '../utils/clearEventDetailsCache';

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const { logout: auth0Logout } = useAuth0();

  const logout = useCallback(() => {
    clearEventDetailsCache();
    setUser(null);
    auth0Logout({ logoutParams: { returnTo: window.location.origin } });
  }, [auth0Logout]);

  const value = useMemo(() => ({
    user,
    setUser,
    logout
  }), [user, logout]);

  return (
    <UserContext.Provider value={value}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error('useUser doit être utilisé dans un UserProvider');
  }
  return context;
};
